
const GraphCheckReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_GRAPH_CHECK':
            return action.payload;
        default:
            return state;
    }
}

export default GraphCheckReducer;